// @ts-nocheck
import React, { useState, useEffect, useContext } from 'react';
import Router from 'next/router';
import { useQuery } from '@tanstack/react-query';
import SCInput from '@/components/sc-controls/form-controls/sc-input';
import SCCheckbox from '@/components/sc-controls/form-controls/sc-checkbox';
import Button from '@/components/button';
import Breadcrumbs from '@/components/breadcrumbs';
import { colors, fontSizes, layout, fontFamily, shadows } from '@/theme';
import Fetch from '@/utils/Fetch';
import ToastContext from '@/utils/toast-context';
import * as Enums from '@/utils/enums';
import SettingsMenu from '@/components/settings/menu';
import Helper from '@/utils/helper';
import ConfirmAction from '@/components/modals/confirm-action';
import OptionService from '@/services/option/option-service';
import Storage from '@/utils/storage';
import RecordSequenceSettings from '@/PageComponents/Settings/RecordSequence/RecordSequenceSettings';
import RecordSequenceHeader from '@/PageComponents/Settings/RecordSequence/RecordSequenceHeader';
import RecordSequenceHint from '@/PageComponents/Settings/RecordSequence/RecordSequenceHint';
import { Box, Flex, Space  } from '@mantine/core';
import { createFileRoute } from '@tanstack/react-router'



function PurchaseOrderSettings() {

  const toast = useContext(ToastContext);
  let currPath = '';
  if (Router.router) {
    currPath = Router.router.asPath;
  }

  const [submitting, setSubmitting] = useState(false);
  const [purchaseSettings, setPurchaseSettings] = useState<any>(null);

  const [formIsDirty, setFormIsDirty] = useState(false);
  const [confirmOptions, setConfirmOptions] = useState(Helper.initialiseConfirmOptions());

  const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);
  
  const getAccessStatus = () => {
    let subscriptionInfo = Storage.getCookie(Enums.Cookie.subscriptionInfo);
    if (subscriptionInfo) {
      setAccessStatus(subscriptionInfo.AccessStatus);
    }
  };

  useEffect(() => {
    getAccessStatus();
  }, []);

  useEffect(() => {
    if (accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
      Helper.nextRouter(Router.replace,"/");
    }
  }, [accessStatus]);  

  const { data: settingsData } = useQuery(
    ['purchaseSettings'],
    () => Fetch.get({ url: `/Option?module=${Enums.Module.PurchaseOrder}` })
  );

  useEffect(() => {
    if (settingsData && !purchaseSettings) {
      setPurchaseSettings(settingsData.Results);
      setInputs(OptionService.getSettingInputs(settingsData.Results));
    }
  }, [settingsData]);

  const [inputs, setInputs] = useState<any>({});
  const [inputErrors, setInputErrors] = useState<any>({});

  const handleInputChange = (e: any) => {
    setInputs({
      ...inputs,
      [e.name]: e.value
    });
    setFormIsDirty(true);
  };

  let settingGroups = OptionService.getSettingGroups(purchaseSettings);
  const groupNames = Object.keys(settingGroups).filter((item: any) => item !== 'Prefix Settings');

  async function saveSettings() {
    setSubmitting(true);
    let newSettings = [...purchaseSettings];
    newSettings.map(function (setting: any) {
      setting.OptionValue = inputs[setting.OptionName]?.toString() ?? null;
    });
    const settingsRes = await Fetch.put({
      url: '/Option',
      params: newSettings,
      toastCtx: toast,
      statusIfNull: true
    });

    if (settingsRes.ResponseStatus == 200) {
      const rowUpdate = await Fetch.get({
        url: `/Option?module=${Enums.Module.PurchaseOrder}`
      });
      setPurchaseSettings(rowUpdate.Results);
      toast.setToast!!!({
        message: 'Purchase order settings updated successfully',
        show: true,
        type: Enums.ToastType.success
      });
    }
    setSubmitting(false);
    setFormIsDirty(false);
    return true;
  }

  Helper.preventRouteChange(formIsDirty, setFormIsDirty, setConfirmOptions, saveSettings);

    const getSettingDetails = (groupName: any) => {
        let group = settingGroups[groupName];
        let results = group.map((setting: any, index: any) => {
            switch (setting.SystemType) {
            case 'System.Boolean':
                return () => <SCCheckbox key={index}
                name={setting.OptionName}
                onChange={() => handleInputChange({ name: setting.OptionName, value: !inputs[setting.OptionName] })}
                value={inputs[setting.OptionName]}
                label={setting.OptionName}
                />
            case 'System.String':
                return () =>
                <SCInput key={index}
                    onChange={handleInputChange}
                    error={inputErrors[setting.OptionName]}
                    label={Helper.splitWords(setting.OptionName)}
                    name={setting.OptionName}
                    hint={setting.Description}
                    required={setting.IsRequired}
                    value={inputs[setting.OptionName]}
                />

            default:
                return null;
            }
        });

        let rows = [];
        let counter = 0;
        for (let index = 0; index < Math.ceil(results.length / 2); index++) {  
            rows.push(() => {return (            
                <div className="row">
                    <div className="column"> {results[counter++]()}</div>
                    {results.length > counter ? <div className="column"> {results[counter++]()} </div> : <></>}
                    <style jsx>{`
                        .row {
                            display: flex;
                        }
                        .column {
                            display: flex;
                            flex-direction: column;
                            width: ${layout.inputWidth};
                        }
                        .column + .column {
                            margin-left: 1.25rem;
                        }
                    `}</style>
                </div>)});
        }

        return rows;
    };

  if (!purchaseSettings) return null;

  return (
    <div className="settings-container">
      {/*<div className="row">
        <div className="title">
          <Breadcrumbs
            crumbs={[
              { text: 'Settings', link: '/settings', suppressLink: true },
              { text: 'Purchase', link: '/settings/purchase/manage' },
            ]}
          />
        </div>
      </div>*/}
      <div className="row">
        <SettingsMenu urlPath={currPath} />
        <div className="settings-card">
          <div className="row">
            <div className="column">
              <h2>Purchase Order Settings</h2>
            </div>
            <div className="column-end">
              <Button disabled={accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess}
                text={submitting ? "Saving" : "Save"} extraClasses="auto save" onClick={saveSettings} />
            </div>
          </div>
          {groupNames.map(function (groupName: any, index: any) {
            return (
              <div key={index}>
                <div className="section-title">
                  {groupName}
                </div>
                {getSettingDetails(groupName).map((item: any) => {
                    return item();
                })}
              </div>
            )
          })}

          <Box mt="xl">
            <RecordSequenceHeader />
          </Box>
          <Flex gap="lg" mt="md">
            <Box style={{ flex: 1 }}>
              <RecordSequenceSettings module={Enums.Module.PurchaseOrder} />
            </Box>
            <Box style={{ flex: 1 }}>
              <RecordSequenceHint />
            </Box>
          </Flex>
        </div>
      </div>

      <ConfirmAction options={confirmOptions} setOptions={setConfirmOptions} />
      <Space h={80} />

      <style jsx>{`
        .row {
          display: flex;
          justify-content: space-between;
        }
        .row-no-justify {
          display: flex;
        }
        .column {
          display: flex;
          flex-direction: column;
          width: ${layout.inputWidth};
        }
        .column-equal {
          flex: 1;
        }
        .column-end {
          align-items: flex-end;
        }
        .column-margin {
          margin-left: 24px;
        }
        
        .title {
          color: ${colors.darkPrimary};
          position: relative;
          width: 100%;
        }
        .title h1 {
          font-size: 24px;
          margin: 6px 0 2rem 0;
        }
        .title p {
          font-size: 14px;
          margin: 0;
        }       
        .section-title {
          background-color: ${colors.background};
          border-radius: ${layout.cardRadius};
          box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
          color: ${colors.bluePrimary};
          font-size: 1.25rem;
          font-weight: bold;
          margin-top: 2rem;
          opacity: 0.9;
          padding: 1rem;
        }
        .small-title {
          color: ${colors.white};
          font-size: 0.875rem;
          font-weight: bold;
          margin-top: 2rem;
        }
        .container :global(.input-container) {
          width: 50%;
        }
        .title :global(.save) {
          margin: 0;
          position: absolute;
          right: 0;
          top: 0;
        }
      `}</style>
    </div>
  );
}

export default PurchaseOrderSettings;

export const Route = createFileRoute('/_authenticated/settings/purchase/manage')({ component: PurchaseOrderSettings })
